import React from "react";
import { useNavigate } from "react-router-dom";

const SafetyTraining = () => {
  const navigate = useNavigate();

  const scrollToTop = (location) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(location);
  };

  const openVideo = (videoUrl) => {
    window.open(videoUrl, "_blank", "width=800, height=600");
  };

  const modules = [
    {
      title: "Driving Pro Black Top",
      image: "/mainImages/playbutton/driving-pro-black-top.png",
      videoUrl: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Black+Top+Driving+Pro.mp4"
    },
    {
      title: "Life-Saving Rules Aware",
      image: "/mainImages/playbutton/lsr-aware.png",
      videoUrl: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/LSR+Aware.mp4"
    },
    {
      title: "Driving Pro Graded Road",
      image: "/mainImages/playbutton/driving-pro-graded-road.png",
      videoUrl: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Graded+Road+Driving+Pro.mp4"
    },
    {
      title: "Life-Saving Rules Road",
      image: "/mainImages/playbutton/lsr-roads.png",
      videoUrl: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Life-Saving+Rules+Road+1.mp4"
    },
    {
      title: "Life-Saving Rules Pro",
      image: "/mainImages/playbutton/lsr-pro.png",
      videoUrl: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/LSR+Pro.mp4"
    },
    {
      title: "Driving Aware All Roads",
      image: "/mainImages/playbutton/driving-aware-all-roads.png",
      videoUrl: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/Driving+Aware.mp4"
    },
    {
      title: "Process Safety",
      image: "/mainImages/playbutton/process-safety.png",
      videoUrl: "https://post-war-video.s3.us-east-1.amazonaws.com/Videos+for+WB+GL/VIRSAT+Process+Safety+3.mp4"
    }
  ];

  return (
    <div className="module-table">
      <div className="module-title">
        <p>Safety Training Modules Showcase</p>
      </div>

      <ul>
        {modules.map((mod, index) => (
          <li key={index} onClick={() => openVideo(mod.videoUrl)}>
            <img className="module" src={mod.image} alt={mod.title} />
            <div className="play-button">▶</div>
          </li>
        ))}
      </ul>

      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <button className="body-button" onClick={() => scrollToTop("/pclicense")}>
          Get Access Now
        </button>
      </div>
    </div>
  );
};

export default SafetyTraining;